import React, { createContext, useContext, useState } from "react";

const TotemContext = createContext();

export const useTotemContext = () => useContext(TotemContext);

export const TotemProvider = ({ children }) => {
    const [totemConfig, setTotemConfig] = useState({
        config: null,
        totem_id: null,
    });

    return (
        <TotemContext.Provider value={{ totemConfig, setTotemConfig }}>
            {children}
        </TotemContext.Provider>
    );
};
